<template>
  <div class="actions">
    <v-btn
      @click="closeModal('SelectAvailableDatesModal')"
      elevation="0"
      color="grey"
      large text>
      {{ cancelLabel }}
    </v-btn>

    <v-btn
      @click="$emit('submitNewDate')"
      :disabled="!hasNewSelectedDateAndTime"
      color="primary"
      elevation="0"
      class="ml-5"
      large dark>
      {{ confirmLabel }}
    </v-btn>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'SelectAvailableDatesActions',

  props: {
    newAppointmentDateInfo: {
      type: Object,
      required: false,
    },
  },

  methods: {
    ...mapActions(['closeModal']),
  },

  computed: {
    hasNewSelectedDateAndTime() {
      return !!this.newAppointmentDateInfo
    },
  },

  data() {
    return {
      cancelLabel: this.$t('announcement.modals.confirmDelete.buttons.cancel'),
      confirmLabel: this.$t('announcement.modals.confirmDelete.buttons.confirm'),
    }
  }
}
</script>
